import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const AnnouncementsSent = () => {
  const routes = all_routes;
  const [filterType, setFilterType] = useState("all");
  const [filterStatus, setFilterStatus] = useState("all");

  const announcements = [
    {
      id: 1,
      title: "Math Quiz Tomorrow",
      content:
        "Reminder: Mathematics quiz on Chapter 5 tomorrow at 10 AM. Please review algebraic equations.",
      type: "reminder",
      audience: "Grade 10A - Mathematics",
      sentDate: "2024-08-05",
      sentTime: "2:30 PM",
      status: "delivered",
      recipients: 30,
      readCount: 28,
      priority: "normal",
    },
    {
      id: 2,
      title: "Homework Extension",
      content:
        "Due to technical issues, homework deadline extended to Friday. Please submit via the portal.",
      type: "update",
      audience: "Grade 11B - Physics",
      sentDate: "2024-08-04",
      sentTime: "4:15 PM",
      status: "delivered",
      recipients: 28,
      readCount: 25,
      priority: "high",
    },
    {
      id: 3,
      title: "Parent-Teacher Meeting",
      content:
        "Parent-teacher meetings scheduled for next week. Please check the calendar for your time slot.",
      type: "event",
      audience: "All Classes",
      sentDate: "2024-08-03",
      sentTime: "11:00 AM",
      status: "delivered",
      recipients: 90,
      readCount: 78,
      priority: "normal",
    },
    {
      id: 4,
      title: "Class Cancelled",
      content:
        "Today's 3rd period class is cancelled due to emergency faculty meeting.",
      type: "urgent",
      audience: "Grade 9C - Mathematics",
      sentDate: "2024-08-02",
      sentTime: "8:45 AM",
      status: "delivered",
      recipients: 32,
      readCount: 30,
      priority: "urgent",
    },
  ];

  const getTypeColor = (type: string) => {
    switch (type) {
      case "urgent":
        return "danger";
      case "reminder":
        return "warning";
      case "update":
        return "info";
      case "event":
        return "success";
      default:
        return "secondary";
    }
  };

  const getPriorityIcon = (priority: string) => {
    switch (priority) {
      case "urgent":
        return "ti-alert-triangle";
      case "high":
        return "ti-chevron-up";
      case "normal":
        return "ti-minus";
      default:
        return "ti-minus";
    }
  };

  const filteredAnnouncements = announcements.filter((announcement) => {
    const typeMatch = filterType === "all" || announcement.type === filterType;
    const statusMatch =
      filterStatus === "all" || announcement.status === filterStatus;
    return typeMatch && statusMatch;
  });

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row mb-4">
            <div className="col">
              <h3 className="page-title mb-2">Announcements Sent</h3>
              <p className="text-muted mb-0">
                View and manage your sent announcements
              </p>
            </div>
          </div>

          {/* Stats Cards */}
          <div className="row mb-4">
            <div className="col-md-3 col-sm-6">
              <div className="card bg-primary-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-primary mb-2">
                    <i className="ti ti-bell text-white fs-2"></i>
                  </div>
                  <h4 className="text-primary">{announcements.length}</h4>
                  <p className="mb-0">Total Sent</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-success-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-success mb-2">
                    <i className="ti ti-check text-white fs-2"></i>
                  </div>
                  <h4 className="text-success">
                    {announcements.reduce((sum, a) => sum + a.recipients, 0)}
                  </h4>
                  <p className="mb-0">Total Recipients</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-info-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-info mb-2">
                    <i className="ti ti-eye text-white fs-2"></i>
                  </div>
                  <h4 className="text-info">
                    {announcements.reduce((sum, a) => sum + a.readCount, 0)}
                  </h4>
                  <p className="mb-0">Total Read</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-warning-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-warning mb-2">
                    <i className="ti ti-percentage text-white fs-2"></i>
                  </div>
                  <h4 className="text-warning">
                    {Math.round(
                      (announcements.reduce((sum, a) => sum + a.readCount, 0) /
                        announcements.reduce(
                          (sum, a) => sum + a.recipients,
                          0
                        )) *
                        100
                    )}
                    %
                  </h4>
                  <p className="mb-0">Read Rate</p>
                </div>
              </div>
            </div>
          </div>

          {/* Filters */}
          <div className="card mb-4">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-4">
                  <label className="form-label">Type</label>
                  <select
                    className="form-select"
                    value={filterType}
                    onChange={(e) => setFilterType(e.target.value)}
                  >
                    <option value="all">All Types</option>
                    <option value="urgent">Urgent</option>
                    <option value="reminder">Reminder</option>
                    <option value="update">Update</option>
                    <option value="event">Event</option>
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label">Status</label>
                  <select
                    className="form-select"
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.target.value)}
                  >
                    <option value="all">All Status</option>
                    <option value="delivered">Delivered</option>
                    <option value="pending">Pending</option>
                    <option value="failed">Failed</option>
                  </select>
                </div>
                <div className="col-md-4 d-flex align-items-end">
                  <button className="btn btn-primary">
                    <i className="ti ti-plus me-1"></i>
                    New Announcement
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Announcements List */}
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Sent Announcements</h5>
            </div>
            <div className="card-body">
              {filteredAnnouncements.length > 0 ? (
                <div className="space-y-3">
                  {filteredAnnouncements.map((announcement) => (
                    <div key={announcement.id} className="card border mb-3">
                      <div className="card-body">
                        <div className="d-flex align-items-start justify-content-between mb-3">
                          <div className="d-flex align-items-start">
                            <div
                              className={`avatar avatar-sm bg-${getTypeColor(
                                announcement.type
                              )}-transparent me-3`}
                            >
                              <i
                                className={`ti ${getPriorityIcon(
                                  announcement.priority
                                )} text-${getTypeColor(announcement.type)}`}
                              ></i>
                            </div>
                            <div>
                              <h6 className="mb-1">{announcement.title}</h6>
                              <span
                                className={`badge bg-${getTypeColor(
                                  announcement.type
                                )} me-2`}
                              >
                                {announcement.type}
                              </span>
                              <span className="text-muted">
                                to {announcement.audience}
                              </span>
                            </div>
                          </div>
                          <div className="text-end">
                            <small className="text-muted d-block">
                              {announcement.sentDate} at {announcement.sentTime}
                            </small>
                            <span className={`badge bg-success`}>
                              {announcement.status}
                            </span>
                          </div>
                        </div>

                        <p className="text-muted mb-3">
                          {announcement.content}
                        </p>

                        <div className="row g-2 mb-3">
                          <div className="col-md-3">
                            <div className="d-flex align-items-center">
                              <i className="ti ti-users me-2 text-muted"></i>
                              <span className="small">
                                {announcement.recipients} recipients
                              </span>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="d-flex align-items-center">
                              <i className="ti ti-eye me-2 text-muted"></i>
                              <span className="small">
                                {announcement.readCount} read
                              </span>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="d-flex align-items-center">
                              <i className="ti ti-percentage me-2 text-muted"></i>
                              <span className="small">
                                {Math.round(
                                  (announcement.readCount /
                                    announcement.recipients) *
                                    100
                                )}
                                % read rate
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex gap-2">
                          <button className="btn btn-sm btn-outline-primary">
                            <i className="ti ti-eye me-1"></i>
                            View Details
                          </button>
                          <button className="btn btn-sm btn-outline-secondary">
                            <i className="ti ti-copy me-1"></i>
                            Duplicate
                          </button>
                          <button className="btn btn-sm btn-outline-info">
                            <i className="ti ti-download me-1"></i>
                            Export
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-5">
                  <div className="avatar avatar-xl bg-light-transparent mx-auto mb-3">
                    <i className="ti ti-bell-off fs-2"></i>
                  </div>
                  <h5>No announcements found</h5>
                  <p className="text-muted">
                    No announcements match your current filter.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnnouncementsSent;
